export default __webpack_public_path__ + "static/section1-background-mobile-d2c980ac962d699097304fd06637ccb0.webp";